import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ standalone: true, name: 'fnCall' })
export class FnCallPipe implements PipeTransform {
  public transform<T, const U extends (...args: T[]) => any>(fn: U, ...args: T[]): ReturnType<U> {
    return fn(...args);
  }
}
